(function () {
  var popup = document.querySelector('[data-open-box-popup]');

  if (!popup) {
    return;
  }

  var closeButtons = popup.querySelectorAll('[data-open-box-popup-close]');
  var previouslyFocusedElement = null;
  var showTimer = null;

  function showPopup() {
    previouslyFocusedElement = document.activeElement;
    popup.hidden = false;
    document.body.classList.add('ul-open-box-popup-is-open');

    window.requestAnimationFrame(function () {
      popup.classList.add('is-visible');
    });

    var firstAction = popup.querySelector('.ul-open-box-popup__cta');
    if (firstAction) {
      firstAction.focus({ preventScroll: true });
    }
  }

  function closePopup() {
    popup.classList.remove('is-visible');
    document.body.classList.remove('ul-open-box-popup-is-open');

    window.setTimeout(function () {
      popup.hidden = true;

      if (
        previouslyFocusedElement &&
        typeof previouslyFocusedElement.focus === 'function'
      ) {
        previouslyFocusedElement.focus({ preventScroll: true });
      }
    }, 280);
  }

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', function (event) {
    if (popup.hidden || event.key !== 'Escape') {
      return;
    }

    closePopup();
  });

  function initPopupDelay() {
    showTimer = window.setTimeout(showPopup, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPopupDelay, { once: true });
  } else {
    initPopupDelay();
  }

  window.addEventListener('pagehide', function () {
    if (showTimer) {
      window.clearTimeout(showTimer);
    }
  });
})();